import styled from 'styled-components';

const Subheader = styled.div`
  ${props => props.theme.typography.subtitle1}
  height: 48px;
  padding: 0 ${props => props.theme.spacing[2]};
  display: flex;
  align-items: center;
`;

export default Subheader;
